import React from "react";
import { FaTimes, FaGithub, FaExternalLinkAlt } from 'react-icons/fa';
import { motion } from 'framer-motion';

export default function ProjectCard({ project, onBack }) {
  // Extract tech stack from subtitle
  const techStack = project.subtitle.split(", ");

  return (
    <div className="bg-gradient-to-br from-gray-800 to-gray-900 p-6 md:p-8 rounded-xl shadow-2xl w-full relative text-white border border-gray-700/50">
      <button 
        onClick={onBack} 
        className="absolute top-4 right-4 z-10 text-gray-400 hover:text-white focus:outline-none transition-colors duration-200 p-2 hover:bg-gray-700/50 rounded-full"
        aria-label="Close"
      >
        <FaTimes size={20} />
      </button>

      <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
        {/* Image Section */}
        <div className="w-full lg:w-1/2 flex-shrink-0">
          <div className="relative rounded-lg overflow-hidden border border-gray-700/50 bg-gray-900">
            <img
              alt={project.title}
              className="object-cover w-full h-auto max-h-[500px]"
              src={project.image}
            />
          </div>
        </div>

        {/* Content Section */}
        <div className="flex-grow lg:w-1/2 text-left space-y-6">
          <div>
            <h1 className="text-3xl md:text-4xl font-bold mb-2 text-white">
              {project.title}
            </h1>
            <p className="text-custom-accent text-sm font-medium mb-4">
              {project.subtitle}
            </p>
            <p className="text-gray-300 leading-relaxed text-base md:text-lg mb-6">
              {project.description}
            </p>
          </div>

          {/* Tech Stack */}
          <div>
            <h3 className="text-sm font-semibold text-gray-400 mb-3 uppercase tracking-wide">
              Technologies
            </h3>
            <div className="flex flex-wrap gap-2">
              {techStack.map((tech, index) => (
                <span
                  key={index}
                  className="text-xs md:text-sm px-3 py-1.5 bg-custom-accent/10 text-custom-accent border border-custom-accent/30 rounded-md font-medium"
                >
                  {tech}
                </span>
              ))}
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 pt-4">
            <motion.a
              href={project.gitlink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 text-custom-accent border-2 border-custom-accent py-3 px-6 focus:outline-none hover:bg-custom-accent hover:text-gray-900 rounded-lg text-base font-medium transition-all duration-300"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaGithub size={18} />
              GitHub
            </motion.a>
            <motion.a
              href={project.hostlink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 text-white bg-gray-700 border-2 border-gray-600 py-3 px-6 focus:outline-none hover:bg-gray-600 hover:border-gray-500 rounded-lg text-base font-medium transition-all duration-300"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaExternalLinkAlt size={16} />
              View Project
            </motion.a>
          </div>
        </div>
      </div>
    </div>
  );
}
